import React from 'react';

import { ReactComponent as EnergyEntry } from 'assets/pics/energy_entry.svg';
import { ReactComponent as GasEntry } from 'assets/pics/gas_entry.svg';
import PropTypes from 'prop-types';

import { EIV_ENTRY_TYPE_TO_GERMAN_NAME, EIV_STATUS_TO_GERMAN_NAME } from 'global/constants';

const OverviewRow = ({ label, value }) => (
  <tr>
    <td>{label}</td>
    <td>{value}</td>
  </tr>
);

OverviewRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

const StatusRow = ({
  icon,
  branch,
  status,
  expireDate,
  entryType,
  companyType,
  shouldExtend,
}) => (
  <tr>
    <td data-label="Sparte">
      <div className="installer-statusbar__table-row-branch">
        {icon}
        <div>{branch}</div>
      </div>
    </td>
    <td data-label="Status">{EIV_STATUS_TO_GERMAN_NAME[status]}</td>
    <td
      data-label="Gültig bis"
      className={shouldExtend ? 'installer-statusbar__table-row-expired' : ''}>
      <div>
        <div>{expireDate}</div>
        {shouldExtend && (
          <div className="installer-statusbar__table-row-expired-text">
            Bitte verlängern Sie Ihre Eintragung
          </div>
        )}
      </div>
    </td>
    <td data-label="Art der Eintragung">{EIV_ENTRY_TYPE_TO_GERMAN_NAME[entryType]}</td>
    <td data-label="Betriebsart">{companyType}</td>
  </tr>
);

StatusRow.propTypes = {
  icon: PropTypes.node.isRequired,
  branch: PropTypes.string.isRequired,
  status: PropTypes.string,
  expireDate: PropTypes.string,
  entryType: PropTypes.string,
  companyType: PropTypes.string,
  shouldExtend: PropTypes.bool,
};

StatusRow.defaultProps = {
  status: '',
  expireDate: '',
  entryType: '',
  companyType: '',
  shouldExtend: false,
};

export const InstallerStatusbarContent = ({ id, energyEntry, gasEntry, limitationEntry }) => (
  <>
    {id && (
      <table className="installer-statusbar__table installer-statusbar__table-overview">
        <tbody>
          <OverviewRow label="Installateurnummer" value={id} />
        </tbody>
      </table>
    )}
    {(energyEntry || gasEntry) && (
      <table className="installer-statusbar__table">
        <thead>
          <tr>
            <th>Sparte</th>
            <th>Status</th>
            <th>Gültig bis</th>
            <th>Art der Eintragung</th>
            <th>Betriebsart</th>
          </tr>
        </thead>
        <tbody>
          {energyEntry && (
            <StatusRow
              {...energyEntry}
              icon={<EnergyEntry width={30} height={30} />}
            />
          )}
          {gasEntry && (
            <StatusRow
              {...gasEntry}
              icon={<GasEntry width={30} height={30} />}
            />
          )}
        </tbody>
      </table>
    )}
    {limitationEntry && (
      <table className="installer-statusbar__table installer-statusbar__table-overview">
        <tbody>
          {limitationEntry.energy && (
            <OverviewRow label="Beschränkung Strom" value={limitationEntry.energy} />
          )}
          {limitationEntry.gas && (
            <OverviewRow label="Beschränkung Gas" value={limitationEntry.gas} />
          )}
        </tbody>
      </table>
    )}
  </>
);

InstallerStatusbarContent.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  energyEntry: PropTypes.shape({
    branch: PropTypes.string,
    status: PropTypes.string,
    expireDate: PropTypes.string,
    entryType: PropTypes.string,
    companyType: PropTypes.string,
    shouldExtend: PropTypes.bool,
  }),
  gasEntry: PropTypes.shape({
    branch: PropTypes.string,
    status: PropTypes.string,
    expireDate: PropTypes.string,
    entryType: PropTypes.string,
    companyType: PropTypes.string,
    shouldExtend: PropTypes.bool,
  }),
  limitationEntry: PropTypes.shape({
    energy: PropTypes.string,
    gas: PropTypes.string,
  }),
};

InstallerStatusbarContent.defaultProps = {
  id: undefined,
  energyEntry: undefined,
  gasEntry: undefined,
  limitationEntry: undefined,
};
